<ng-container *ngIf="(authStatus | async) && !isCallback">
  <cpak-navigation-bar *ngIf="(fullscreenState$ | async) === false"></cpak-navigation-bar>

  <div [class.fullscreen]="fullscreenState$ | async" class="layout">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<ng-container
  *ngIf="((authStatus | async) && isCallback) || ((authStatus | async) === false && (isLoginFailed$ | async) === true)"
>
  <div [class.fullscreen]="fullscreenState$ | async" class="layout">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<cpak-compare-products-bar *ngIf="isCompareBarVisible$ | async"></cpak-compare-products-bar>

<div *ngIf="(authStatus | async) === false && (isLoginFailed$ | async) === false" class="cpak-spinner"></div>

<p-toast
  [class.lift-when-compare-bar-visible]="isCompareBarVisible$ | async"
  position="bottom-center"
  [key]="globalToastKey"
>
</p-toast>
<p-toast
  [class.lift-when-compare-bar-visible]="isCompareBarVisible$ | async"
  position="bottom-center"
  [preventOpenDuplicates]="true"
  [key]="globalErrorLostConnectionToastKey"
>
</p-toast>
